export const PLACES_AUTOCOMPLETE_API_URL = 'https://maps.googleapis.com/maps/api/place/autocomplete/json'; // prettier-ignore
export const PLACES_LIBRARY_URL = 'https://maps.googleapis.com/maps/api/js?libraries=places'; // prettier-ignore
export const PLACES_GEOCODE_URL = 'https://maps.googleapis.com/maps/api/geocode/json'; // prettier-ignore

/**
 * @see {@link https://developers.google.com/maps/documentation/places/web-service/legacy/supported_types}
 */
export const PLACES_TYPES = {
  REGION: '(regions)',
  ADDRESS: 'address',
  GEOCODE: 'geocode',
};

export const PLACES_API_COUNTRY = 'us';
